import { IMultipleIdsParams } from '../../ts/ServerApi/types/actionParams';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { Request } from '../../httpClient/serverApi/requests/Request';

export class DeleteSchedulesRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('deleteSchedules', { ids: ids });
  }
}
